import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Popup from 'components/Popup';
import { useSelector } from 'react-redux';
import InputText from 'components/Inputs/inputText';
import { Button } from 'xland-ui';
import { IM_FOUNDER, INVITE_FOUNDER } from '.';

function PopupInvite({ type, onClose }) {
  const literals = useSelector(state => state.i18n.literals.prehome);
  const literalsCommon = useSelector(state => state.i18n.literals.common);
  const user = useSelector(state => state.session.user);

  const [data, setData] = useState({ name: '', email: '', startup: '' });

  const fields = [
    { id: 'name', preText: literals.writeYourName },
    { id: 'email', preText: literals.writeFounderEmail, hidden: type !== INVITE_FOUNDER },
    { id: 'startup', preText: literals.writeStartupName },
  ];

  const handleChange = field => v => setData({ ...data, [field]: v });

  const handleSubmit = () => {
    const auxData = { ...data };
    if (type === IM_FOUNDER) {
      auxData.email = user.email;
    }
  };

  return (
    <Popup onClose={onClose} title={literals[type]} size='small'>
      {fields.filter(field => !field.hidden).map(field => (
        <InputText
          key={field.id}
          preText={field.preText}
          placeholder={literalsCommon[field.id]}
          value={data[field.id]}
          onChange={handleChange(field.id)}
        />
      ))}
      <div className='buttons'>
        <Button onClick={handleSubmit}>{literalsCommon.confirm}</Button>
      </div>
    </Popup>
  );
}

PopupInvite.propTypes = {
  type: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default PopupInvite;
